import {h, Component} from 'preact';
import {API} from 'globals';
import firebase from 'utils/firebase';

class AuthProvider extends Component {
	fetch = (url, options) => new Promise((resolve,reject) => {
		// method: 'POST',
		// body: JSON.stringify(payload);

		const user = firebase.auth().currentUser;

		if(!user) {reject('Ei pääsyä')}

		user.getIdToken()
		.then((token) => {

			fetch(`${API}${url}`,  {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + token
				},
				...options
			})
			.then(res => res.json())
			.then(resolve)
			.catch(reject)
	    })
		.catch(reject)

	})




	componentDidMount(){
		firebase.auth()
		.onAuthStateChanged((user) => {
			if(!user) {
				this.setState({user : firebase.auth().currentUser })

			} else {
				const currentUser = firebase.auth().currentUser;
				const db = firebase.firestore();
				db.collection("user")
				.doc(currentUser.uid)
				.get()
				.then((doc) => {
					console.log('admin check', doc.data().admin);
					if (doc.exists && doc.data().admin) {
						this.setState({user: {...currentUser, admin: true}})
				    } else {
						console.log('not admin');

						this.setState({user : currentUser })
				    }
				})
				.catch(err => {
					console.log('not admin',currentUser.uid, err);
					this.setState({user : currentUser })

				})
			}

		});
	}
	getChildContext(){
		return {
			user: this.state.user,
			http: this.fetch,
			updateProfile: (profile) => {
				const user = firebase.auth().currentUser;

				user.updateProfile(profile)
				.then(() => this.setState({ user : {...firebase.auth().currentUser, admin: this.state.user ? this.state.user.admin : false}}) )
			}
		}
	}
	render(props){return props.children[0]}
}

export default AuthProvider



// WEBPACK FOOTER //
// ./components/auth/index.js